import React from "react";

import EmprestimoFormPageContainer from "./EmprestimoFormPageContainer";

export class EmprestimoFormPage extends React.Component {
  render() {
    return <EmprestimoFormPageContainer {...this.props} />;
  }
}
